<!--  ############### Footer Start ################# -->
<footer class="footer"><span style="font-size:14px;">DirectTime</span>
  <span class="text-muted" style="padding-left:20px;">&copy; {{"CopyRightTxt" | translate}}.</span>
  <!-- <span class="float-end"><button onclick="topFunction()" id="topBtn" title="Go to top">{{"FooterTopTxt" | translate}}</button></span> -->
</footer>
<!--  ############### Footer End ################# -->
